import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $charge, $inputs } = this;

  return (view = ViewFactory({
    NAME: 'MOMO_FRANCO_OTP_VIEW',
    inputs: ['otp'],
    constants: {
      get phone() { return getValueAtPath($inputs, '[phone].value') },
      get selectedNetwork() { return getValueAtPath($inputs, '[network].value') }
    },
    next() {
      const {
        charge: flw_reference = null,
        order: transactionreference = null
      } = isPlainObject($this.reference) ? $this.reference : {};

      const otp = getValueAtPath($inputs, '[otp].value');

      if (otp) {
        $charge.validate({
          data: { otp, flw_reference, transactionreference },
          onSuccessful() { SuccessView && SuccessView.activate.call($this) },
          onComplete() { /* self.console.log({ ...$this }) */ }
        });
      }
    }
  }).call(this));
}
